import { forwardRef, type PropsWithChildren } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';
import { type HTMLMotionProps, motion } from 'framer-motion';

import css from './styles.module.scss';

const infoWrapperVariants = cva('', {
  variants: {
    variant: {
      default: css.default,
    },
    triangle: {
      left: css.triangleLeft,
      right: css.triangleRight,
      top: css.triangleTop,
      bottom: css.triangleBottom,
    },
  },
});

interface InfoWrapperProps
  extends Omit<HTMLMotionProps<'div'>, 'children'>,
    PropsWithChildren,
    VariantProps<typeof infoWrapperVariants> {
  triangleClassName: string;
}

const InfoWrapper = forwardRef<HTMLDivElement, InfoWrapperProps>(
  (
    {
      children,
      variant = 'default',
      triangle = 'bottom',
      triangleClassName,
      ...props
    },
    ref,
  ) => {
    return (
      <motion.div
        ref={ref}
        {...props}
        className={cn(infoWrapperVariants({ variant }), props.className)}
      >
        <div className="relative w-full h-full p-3">
          <span
            className={cn(
              infoWrapperVariants({ triangle }),
              css.triangle,
              triangleClassName,
            )}
          ></span>
          {children}
        </div>
      </motion.div>
    );
  },
);

export { InfoWrapper };
